import { openkit } from "../../library/database";

export const addBikeToCart = async (
  product,
  info,
  extraReservationConfig,
  clientRequest,
  setAddedToCart
) => {
  const cartItem = {
    type: "rentabike",
    product_id: product.id,
    client_id: info.user.id,
    pickup_loc: info.rentabike?.pickup_loc,
    pickup_date: info.rentabike?.pickup_date?.format(),
    pickup_time: info.rentabike?.pickup_time,
    return_loc: info.rentabike?.return_loc,
    return_date: info.rentabike?.return_date?.format(),
    return_time: info.rentabike?.return_time,
    extras: extraReservationConfig,
    request: clientRequest,
  };
  await openkit.data.create("c_reservation_lines", cartItem);
  setAddedToCart(true);
};
